import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import Utils from '../../../utils';
import StatsUtils from '../../../utils/statistics';
import { StoreState } from '../../../reducers';
import { DriveItemListDisplayType } from '../constants';
import { updateDriveItemListDisplayType } from '../actions';
import { DriveListState } from '../reducer';
import { StyledDriveItemListViewSwitcher } from './styles';
import UserAgentUtils from '../../../utils/userAgent';
import Tooltip from '../../../components/Tooltip';

export interface DriveItemListViewSwitcherProps {
	dispatch: Dispatch<StoreState>;
	driveList: DriveListState;
}

const DISPLAY_ORDER = [DriveItemListDisplayType.Masonry, DriveItemListDisplayType.Grid, DriveItemListDisplayType.Row];

class DriveItemListViewSwitcher extends React.Component<DriveItemListViewSwitcherProps, {}> {

	render() {
		const { displayType } = this.props.driveList;
		const tooltipId = Utils.generateId();

		const currentTypeIndex = DISPLAY_ORDER.indexOf(displayType);
		const nextType = currentTypeIndex < DISPLAY_ORDER.length - 1 ? DISPLAY_ORDER[currentTypeIndex + 1] : DISPLAY_ORDER[0];
		let icon = '';
		let text = '';

		switch (nextType) {
			case DriveItemListDisplayType.Masonry:
				icon = 'iconset_masonry';
				text = 'messages.masonry';
				break;
			case DriveItemListDisplayType.Grid:
				icon = 'pages';
				text = 'messages.grid';
				break;
			case DriveItemListDisplayType.Row:
				icon = 'iconset_list';
				text = 'messages.row';
				break;
		}

		return (
			<StyledDriveItemListViewSwitcher onClick={() => this.setDisplayType(nextType)} data-tip={true} data-for={tooltipId} key={`tooltip-${tooltipId}`}>
				{Utils.getSvgIcon(icon)}
				{UserAgentUtils.isDesktop() && <Tooltip id={tooltipId} text={text} />}
			</StyledDriveItemListViewSwitcher>
		);
	}

	private setDisplayType(displayType: DriveItemListDisplayType): void {
		const { dispatch } = this.props;
		dispatch(updateDriveItemListDisplayType(displayType));

		StatsUtils.trackDisplayType(displayType);
	}
}

const mapStateToProps = (state: StoreState) => {
	const { driveList } = state;
	return { driveList };
};

export default connect(mapStateToProps)(DriveItemListViewSwitcher);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Switcher/index.tsx